<div class="flex-1 flex flex-col overflow-hidden">
  <!-- Main Content Area -->
  <div class="flex-1 overflow-auto p-6">
    <!-- Header Section -->
    <div class="flex justify-between items-center mb-8">
      <div class="flex items-center space-x-2">
        <button
          (click)="onCancel()"
          class="flex items-center space-x-2 hover:text-blue-600 transition-colors duration-200"
        >
          <i class="pi pi-arrow-left text-gray-600 text-xl"></i>
          <h1 class="text-2xl font-semibold text-gray-800">
            Reply of {{ documentName }}
          </h1>
        </button>
      </div>
    </div>

    <!-- Reply Form -->
    <div
      class="bg-white rounded-lg shadow-sm border border-gray-200 p-8 max-w-4xl"
    >
      <form [formGroup]="replyForm" (ngSubmit)="onSubmit()" class="space-y-6">
        <!-- Reply Date -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="space-y-2">
            <label class="block text-sm font-medium text-gray-700">
              Reply Date
            </label>
            <div class="relative datepicker-wrapper">
              <p-datepicker
                formControlName="replyDate"
                dateFormat="dd-mm-yy"
                [appendTo]="'body'"
                [iconDisplay]="'input'"
                [showIcon]="true"
                [showButtonBar]="false"
                [showOnFocus]="true"
                [readonlyInput]="false"
                [inline]="false"
                [touchUI]="false"
                [invalid]="isInvalid('replyDate')"
                class="w-full"
                ngDefaultControl
              />
              @if (isInvalid('replyDate')) {
              <p-message severity="error" size="small" variant="simple"
                >Date is required.</p-message
              >
              }
            </div>
          </div>

          <!-- Reply Time -->
          <div class="space-y-2">
            <label class="block text-sm font-medium text-gray-700">
              Reply Time
            </label>
            <div class="relative">
              <input
                type="text"
                pInputText
                formControlName="replyTime"
                placeholder="14:00"
                class="w-full input-field"
                ngDefaultControl
              />
              <i
                class="pi pi-clock absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
              ></i>
              @if (isInvalid('replyTime')) {
              <p-message severity="error" size="small" variant="simple"
                >Time is required.</p-message
              >
              }
            </div>
          </div>
        </div>

        <!-- Reply To -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="space-y-2">
            <label class="block text-sm font-medium text-gray-700">
              Reply To <span class="text-red-500">*</span>
            </label>
            <p-select
              formControlName="replyTo"
              [options]="replyToUsers"
              optionLabel="fullName"
              optionValue="id"
              placeholder="Select User"
              [loading]="isLoadingUsers"
              [disabled]="isLoadingUsers"
              class="w-full"
              [invalid]="isInvalid('replyTo')"
              ngDefaultControl
            ></p-select>
            @if (isInvalid('replyTo')) {
            <p-message severity="error" size="small" variant="simple"
              >Reply To is required.</p-message
            >
            }
          </div>
        </div>

        <!-- Subject -->
        <div class="space-y-2">
          <label class="block text-sm font-medium text-gray-700">
            Subject <span class="text-red-500">*</span>
          </label>
          <textarea
            pTextarea
            formControlName="replySubject"
            placeholder="Enter Here"
            class="w-full min-h-[100px] textarea-field"
            ngDefaultControl
          ></textarea>
          @if (isInvalid('replySubject')) {
          <p-message severity="error" size="small" variant="simple"
            >Subject is required.</p-message
          >
          }
        </div>

        <!-- Action Buttons -->
        <!-- Action Buttons -->
        <div class="flex justify-end space-x-4 pt-6">
          <p-button
            type="button"
            label="Cancel"
            class="button btn-cancel"
            (onClick)="onCancel()"
          >
          </p-button>
          <p-button
            type="submit"
            label="Submit"
            class="button btn-submit"
            [disabled]="replyForm.invalid || isLoading"
            [loading]="isLoading"
          >
          </p-button>
        </div>
      </form>
    </div>
  </div>

  <!-- Toast Messages -->
  <p-toast position="top-right"></p-toast>
</div>
